import { Hostname, IPV4AddressAndPort, IPV6AddressAndPort } from './models'

export type SolarPortDriver = 'SPP_SOLAR_DRIVER_SUNSPEC' | 'SPP_SOLAR_DRIVER_STECAGRID' | 'SPP_SOLAR_DRIVER_SOLIS' | 'SPP_SOLAR_DRIVER_SOFAR_G3' | 'SPP_SOLAR_DRIVER_SOFAR_G2' | 'SPP_SOLAR_DRIVER_RELAYED'

/**
 * Communication baudrates.
 */
export type BaudRate = 'AUTO' | 4800 | 9600 | 19200 | 38400 | 57600 | 115200 | 230400 | 250000 | 460800 | 921600 | 1000000
export const baudrates = {
  AUTO: 'AUTO',
  4800: '4800',
  9600: '9600',
  19200: '19200',
  38400: '38400',
  57600: '57600',
  115200: '115200',
  230400: '230400',
  250000: '250000',
  460800: '460800',
  921600: '921600',
  1000000: '1000000',
}

/**
 * Communication parity.
 */
export type Parity = 'ODD' | 'EVEN' | 'NO_PARITY'

/**
 * Solar panel configuration.
 */
export type SolarPortConfigConnectionType = 'SOLAR_CONN_TYPE_MODBUS_RTU_RS485_0' |
 'SOLAR_CONN_TYPE_MODBUS_RTU_RS485_1' |
 'SOLAR_CONN_TYPE_MODBUS_TCP_IP4ADDR' |
 'SOLAR_CONN_TYPE_MODBUS_TCP_IP6ADDR' |
 'SOLAR_CONN_TYPE_MODBUS_TCP_HOSTNAME'

export type SolarPortSunspecConfigParams = {
  conn_type: SolarPortConfigConnectionType,

  conn_params: {
    baudrate: BaudRate,
    parity: Parity,
  } | IPV4AddressAndPort | IPV6AddressAndPort | Hostname,

  slave_id: number

  extras: [
    [number, number],
    [number, number],
    [number, number],
    [number, number],
    [number, number],
  ]
}

export type SolarPortStecaGridConfigParams = {
  rs485_baudrate: BaudRate,
  rs485_mode: '8N1' | '8N2' | '8E1' | '8O1',
  rs485_instance: 0 | 1,
  our_id: number,
  slave_id: number,
  auth_level: 'CUSTOMER' |'SERVICE' |'DEVELOPMENT' |'ADMINISTRATOR',
}

export type SolarPortSolisConfigParams = {
  conn_type: SolarPortConfigConnectionType,

  slave_id: number,

  extras: [
    { func_code: number, reg_addr: number},
    { func_code: number, reg_addr: number},
    { func_code: number, reg_addr: number},
    { func_code: number, reg_addr: number},
    { func_code: number, reg_addr: number},
  ]
}

export type SolarPortRelayedConfigParams = {
}

export type SolarPortConfigParams = SolarPortSunspecConfigParams | SolarPortStecaGridConfigParams | SolarPortSolisConfigParams | SolarPortRelayedConfigParams
